// extracted by mini-css-extract-plugin
export default {"body":"CAMSelect_body__knGyt"};